import { Spinner } from './Spinner';
import * as React from 'react';
import { useAppSelector } from '../../Store/store';
import { overLayerSelector, popupBlockedSelector } from '../../Store/layoutSlice';
import Icon from './Icon';
import { CONNECTED_API_TYPE } from '../../Model/Enums';
import { ListItem } from './ListItem';

export const OverLayer = () => {
  const overLayerVisible = useAppSelector(overLayerSelector);
  const popupBlocked = useAppSelector(popupBlockedSelector);

  return (
    <>
      {overLayerVisible && (
        <>
          {popupBlocked && (
            <div className="fixed-top w-100 vh-100 top-0  d-flex align-items-center justify-content-center bg-dark text-center overflow-y mb-2">
              <div className="container d-flex flex-column  p-2 my-2 h-100 ">
                <p className="fs-5 text-center p-1  bg-warning">
                  Az <Icon originate={CONNECTED_API_TYPE.AGGREG8} style={{ width: '75px' }} /> API bekötés esetén,
                  lehetővé kell tenni a böngésző számára az előugró ablakok használatát!
                </p>
                <h5 className="fw-bold p-1 my-2 bg-white">
                  Kérem ellenőrizze a böngészőjét, hogy ez a funkció engedélyezve van-e!
                </h5>
                <ul className="list-group mb-2">
                  <ListItem
                    title="Chrome böngésző esetén:"
                    src="/img/chrome_popup.jpg"
                    alt="Popup engedélyezés chrome böngészőben"
                  />
                  <ListItem
                    title="Firefox böngésző esetén:"
                    src="/img/firefox_popup.jpg"
                    alt="Popup engedélyezés firefox böngészőben"
                  />
                  <ListItem
                    title="Edge böngésző esetén:"
                    src="/img/edge_popup.jpg"
                    alt="Popup engedélyezés edge böngészőben"
                  />
                </ul>
              </div>
            </div>
          )}

          {!popupBlocked && (
            <div className="fixed-top w-100 min-vh-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 text-center">
              <Spinner colorClass={'text-danger'} style={{ width: '9rem', height: '9rem' }} />{' '}
            </div>
          )}
        </>
      )}
    </>
  );
};
